import { render, staticRenderFns } from "./ModifierModalEdit.vue?vue&type=template&id=4dcbafed&scoped=true&"
import script from "./ModifierModalEdit.vue?vue&type=script&lang=js&"
export * from "./ModifierModalEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModifierModalEdit.vue?vue&type=style&index=0&id=4dcbafed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcbafed",
  null
  
)

export default component.exports